import { render, staticRenderFns } from "./researchList.vue?vue&type=template&id=1de2ce98&"
import script from "./researchList.vue?vue&type=script&lang=js&"
export * from "./researchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports